export default __webpack_public_path__ + "static/kb_3_2-77f17e58d929cf8caf9f75ddc41dc855.jpeg";